export default {
  title: 'Importación de facturas. Resultado de la importación',
  table: {
    file: 'Fichero',
    provider: 'Proveedor',
    client: 'Cliente',
    number: 'Nº de Factura',
    ammount: 'Importe',
    result: 'Resultado',
    comment: 'Comentario'
  },
  correct: 'Facturas correctas',
  incorrect: 'Facturas repudiadas',
  notTreated: 'Facturas No tratadas',
  total: 'Total de Facturas',
  error: 'La importación ha fallado. Revise las facturas incorrectas. No se ha registrado ninguna factura. Para continuar pulse Aceptar.',
  partialError: 'La importación ha fallado. Revise la factura incorrecta. No se ha registrado {0} factura. Para continuar pulse Aceptar. | La importación ha fallado. Revise las facturas incorrectas. No se han registrado {0} facturas. Para continuar pulse Aceptar.',
  success: 'La importación se ha completado. Se ha importado {0} factura. Para continuar pulse Aceptar. | La importación se ha completado. Se han importado {0} facturas. Para continuar pulse Aceptar.'
}
